import { TerminCreateApi } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import TerminCreate from '../../model/TerminCreate';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new TerminCreateApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const createTermin = async (
  tezaurusUuid: Uuid,
  terminCreate: TerminCreate,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<string>> => {
  const { data, status } = await client.createTermin(tezaurusUuid, terminCreate, options);
  return { data, responseCode: status };
};
